import { useEffect, useState } from "react";
import { IPETest } from "../data/interfaces";
import { ITestsStore, useTestsStore } from "../data/store";
import { ID } from "@libs/interfaces/layouts";

export default function useGenTest(): IPETest {
    const genTests: IPETest[] = useTestsStore((state:ITestsStore) => state.genTests) 
    const genCurrentID: ID = useTestsStore((state:ITestsStore) => state.genCurrentID) 
    const [genTest, setGenTest] = useState<IPETest>({} as IPETest)
    useEffect(() => {
        // console.log( genTests )
        // console.log( genCurrentID )
        const _genTest = genTests.find(gt => gt.id === genCurrentID)
        // console.log( _genTest )
        if(!!_genTest) {
            setGenTest( _genTest )
        }
    }, [ genCurrentID, genTests ] )
    // console.log( genTest )
    return genTest
}